import { render, staticRenderFns } from "./EditUnitWorkCompositeUnitModal.vue?vue&type=template&id=c0787268"
import script from "./EditUnitWorkCompositeUnitModal.vue?vue&type=script&lang=js"
export * from "./EditUnitWorkCompositeUnitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports